var map = {
	"./077---StartSword.json": 98580,
	"./078---AdminWeapon.json": 22612,
	"./079---QuickSword.json": 5001,
	"./080---RevengeSword.json": 20599,
	"./081---BackStabber.json": 81432,
	"./082---Bleeder.json": 4209,
	"./083---DualDaggers.json": 19437,
	"./084---BroadSword.json": 23342,
	"./085---Shovel.json": 75115,
	"./086---EvilSword.json": 27157,
	"./087---BleedCrit.json": 93644,
	"./088---SpeedBlade.json": 17900,
	"./089---GiantKiller.json": 27757,
	"./090---BulletBlade.json": 77864,
	"./091---SismicBlade.json": 80548,
	"./092---Spear.json": 69361,
	"./093---ImpaleSpear.json": 70339,
	"./094---KingsSpear.json": 98754,
	"./095---Rapier.json": 51616,
	"./096---DashSword.json": 40932,
	"./097---StunMace.json": 65045,
	"./098---BumpBoots.json": 58308,
	"./099---SpikedBoots.json": 17391,
	"./100---MultiKickBoots.json": 34854,
	"./101---QuickFists.json": 44550,
	"./102---Whip.json": 38163,
	"./103---HookWhip.json": 36767,
	"./104---OilSword.json": 71267,
	"./105---Burner.json": 30225,
	"./106---LowHealth.json": 16715,
	"./107---PerfectHalberd.json": 74768,
	"./108---BehemothHammer.json": 29335,
	"./109---TentacleWhip.json": 95098,
	"./110---Pan.json": 72198,
	"./111---ParryBlade.json": 75840,
	"./112---TickScytheLeft.json": 97199,
	"./113---TickScytheRight.json": 8642,
	"./114---RhythmicBlade.json": 12703,
	"./115---Crowbar.json": 80717,
	"./116---SnakeFang.json": 89353,
	"./117---GiantStaff.json": 1157,
	"./118---Lantern.json": 64654,
	"./119---NotFlyingSword.json": 73465,
	"./120---Katana.json": 97971,
	"./121---ExplosiveCrossBowOffHand.json": 70054,
	"./122---Tombstone.json": 59,
	"./123---HeavyAxe.json": 43139,
	"./124---Club.json": 65889,
	"./125---ClubBroken.json": 26162,
	"./126---MachetePistol.json": 82298,
	"./127---HardLightSword.json": 80308,
	"./128---PureNail.json": 30606,
	"./129---SkulBone.json": 63752,
	"./130---Trident.json": 83356,
	"./131---HandHook.json": 52702,
	"./132---Shark.json": 62436,
	"./133---ElbowBlades.json": 46352,
	"./134---WreckingBall.json": 71442,
	"./135---QueenRapier.json": 97724,
	"./136---CupidityDagger.json": 71261,
	"./137---GoldDigger.json": 84443,
	"./138---GoldDiggerEvolved.json": 67747,
	"./139---KingScepter.json": 67489,
	"./140---BaseballBat.json": 80973,
	"./141---NunchuckPan.json": 85904,
	"./142---Starfury.json": 54440,
	"./143---TPSword.json": 58845,
	"./144---WiggleWhip.json": 2260,
	"./145---Bible.json": 719,
	"./146---SnakeSwordWeapon.json": 39746,
	"./147---SnakeSwordWeaponAlt.json": 44449,
	"./148---SnakeSwordSwap.json": 35286,
	"./149---VampireKiller.json": 92470,
	"./150---AdeleScythe.json": 78434,
	"./151---RichterVampireKiller.json": 87085,
	"./152---CombinedTickScythe.json": 72581,
	"./153---Pistol.json": 58991,
	"./154---Scissor.json": 47289,
	"./155---Comb.json": 59747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34649;